import { Column } from '../../model/common/column';
import { SelectItem } from '@openng/optimus-ui/api';

export function getCommercialContactTableColumns(
  availableCompanies: SelectItem[],
  availableJobRoles: SelectItem[],
  isMobile: boolean
): Column[] {
  if (isMobile) {
    return [
      {
        field: 'fullName',
        header: 'COMMERCIAL_SERVICES.LABEL.FULL_NAME',
        mobileHeader: 'COMMERCIAL_SERVICES.LABEL.FULL_NAME',
        hideMobileLabel: true,
        formatPattern: 'hyperlink',
        width: '55%',
        sortable: true,
        filterable: true,
        matchMode: 'contains',
      },
      {
        field: 'company',
        header: 'COMMERCIAL_SERVICES.LABEL.COMPANY',
        mobileHeader: 'COMMERCIAL_SERVICES.LABEL.COMPANY',
        hideMobileLabel: true,
        formatPattern: 'text',
        type: 'dropdown',
        subField: 'name',
        width: '45%',
        sortable: true,
        filterable: true,
        options: availableCompanies,
        matchMode: 'contains',
      },
    ];
  }

  const retVal: Column[] = [];

  retVal.push(
    {
      field: 'firstName',
      header: 'COMMERCIAL_SERVICES.LABEL.FIRST_NAME',
      formatPattern: 'text',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'lastName',
      header: 'COMMERCIAL_SERVICES.LABEL.LAST_NAME',
      formatPattern: 'text',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    }
  );

  retVal.push(
    {
      field: 'company',
      header: 'COMMERCIAL_SERVICES.LABEL.COMPANY',
      formatPattern: 'text',
      type: 'dropdown',
      subField: 'name',
      width: '14%',
      sortable: true,
      filterable: true,
      options: availableCompanies,
      matchMode: 'contains',
    },
    {
      field: 'jobRole',
      header: 'COMMERCIAL_SERVICES.LABEL.ROLE',
      formatPattern: 'text',
      type: 'dropdown',
      subField: 'name',
      options: availableJobRoles,
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'deskPhone',
      header: 'COMMERCIAL_SERVICES.LABEL.OFFICE_NUMBER',
      mobileHeader: 'COMMERCIAL_SERVICES.LABEL.OFFICE_NUMBER',
      formatPattern: 'text',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'startsWith',
    },
    {
      field: 'mobilePhone',
      header: 'COMMERCIAL_SERVICES.LABEL.MOBILE_NUMBER',
      mobileHeader: 'COMMERCIAL_SERVICES.LABEL.MOBILE_NUMBER',
      formatPattern: 'text',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'startsWith',
    },
    {
      field: 'emailAddress',
      header: 'COMMERCIAL_SERVICES.LABEL.EMAIL',
      mobileHeader: 'COMMERCIAL_SERVICES.LABEL.EMAIL',
      formatPattern: 'text_lower',
      width: '14%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'ice',
      header: 'COMMERCIAL_SERVICES.LABEL.ICE',
      mobileHeader: 'COMMERCIAL_SERVICES.LABEL.ICE',
      formatPattern: 'text',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'startsWith',
    }
  );

  return retVal;
}
